export const FETCH_SYSTEM_CONFIG = 'FETCH_SYSTEM_CONFIG';
export const FETCH_SYSTEM_CONFIG_SUCCESS = 'FETCH_SYSTEM_CONFIG_SUCCESS';
export const FETCH_SYSTEM_CONFIG_ERROR = 'FETCH_SYSTEM_CONFIG_ERROR';

export const fetchConfig = () => ({ type: FETCH_SYSTEM_CONFIG });
